import { AbstractControl, ValidationErrors } from "@angular/forms";

export function validateNumeric(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const hasValue = value?.trim();
    return hasValue && !value.test("^-?\\d+$") ? { mustBeNumeric: true } : null;
}